import { defineComponent } from "vue"

export default defineComponent({
  props: {
    items: {
      type: Array as VuePropType<string[]>,
      required: true,
    },
  },

  data: () => ({
    openedImg: null as number | null,
  }),

  computed: {
    arrayChunks () {
      const temp: string[][] = []

      for (let i = 0; i < this.items.length; i += 6)
        temp.push(this.items.slice(i, i + 6))

      return temp
    },
  },

  mounted () {
    window.addEventListener("keyup", (e) => {
      if (this.openedImg === null) return

      switch (e.key) {
        case "ArrowLeft":
          this.switchPhoto("left")
          break

        case "ArrowRight":
          this.switchPhoto("right")
          break

        case "Escape":
          this.openedImg = null
          break
      }
    })
  },

  methods: {
    switchPhoto (direction: "left" | "right") {
      if (this.openedImg === null)
        return

      if (direction === "left" && this.openedImg > 0)
        this.openedImg--

      else if (
        direction === "right" &&
          this.openedImg < this.items.length - 1
      ) this.openedImg++
    },
  },
})
